import { createApiClient } from 'Network/ApiClient';

export const DrugAllowedwithIcdAxiosInstance = createApiClient('DrugsNotIcd/');


